(() => {
  const data = document.getElementById('as-catalogue-names');
  if (!data) return;
  let names;
  try { names = JSON.parse(data.textContent); } catch (_) { return; }
  function update(list) {
    list.querySelectorAll('.mini-cart__item-title > a').forEach(link => {
      let handle;
      try { handle = decodeURIComponent(new URL(link.href).pathname.split('/products/')[1] || ''); } catch (_) { return; }
      const entry = names[handle];
      const text = link.textContent.trim();
      if (entry && text.startsWith(entry.original)) link.textContent = entry.name + text.slice(entry.original.length);
    });
  }
  function boot() {
    document.querySelectorAll('.js-cart_items').forEach(list => {
      if (list.dataset.asNamesReady) return;
      list.dataset.asNamesReady = 'true';
      update(list);
      new MutationObserver(() => update(list)).observe(list, {childList:true, subtree:true});
    });
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
